import {useTranslation} from "react-i18next";
import {Page} from "../components/common";
import {Container, Typography} from "@mui/material";

export const SettingsPage = () => {
    const {t} = useTranslation(['navigation']);
    const title = t('settings');
    return <Page title={`${title} | Kocha`}>
        <Container maxWidth="xl">
            <Typography variant="h4">{title}</Typography>
        </Container>
    </Page>
}
